import { Option as AccessOption } from '@/react/portainer/access-control/AccessManagement/PorAccessManagementUsersSelector';

import type { Option as PortainerOption } from '@@/form-components/PortainerSelect';

import { UserTeamSelector } from '../../../../UserTeamSelector';

import { columnHelper, type AccessRow } from './helper';

interface AccessColumnProps {
  userTeamOptions: PortainerOption<AccessOption>[];
  users: AccessOption[];
  teams: AccessOption[];
  handleAccessChange: (
    item: AccessRow,
    selection: readonly AccessOption[]
  ) => void;
}

function toOptions(
  row: AccessRow,
  users: AccessOption[],
  teams: AccessOption[]
): AccessOption[] {
  const userMap = new Map(users.map((u) => [u.Id, u]));
  const teamMap = new Map(teams.map((t) => [t.Id, t]));
  const userOpts = row.userIds
    .map((id) => userMap.get(id))
    .filter(Boolean) as AccessOption[];
  const teamOpts = row.teamIds
    .map((id) => teamMap.get(id))
    .filter(Boolean) as AccessOption[];
  return [...userOpts, ...teamOpts];
}

export function createAccessColumn({
  userTeamOptions,
  users,
  teams,
  handleAccessChange,
}: AccessColumnProps) {
  return columnHelper.display({
    id: 'access',
    header: 'Access',
    // eslint-disable-next-line react/no-unstable-nested-components
    cell: ({ row }) => (
      <UserTeamSelector
        options={userTeamOptions}
        value={toOptions(row.original, users, teams)}
        onChange={(value) => handleAccessChange(row.original, value)}
      />
    ),
    meta: {
      className: 'w-2/3',
    },
  });
}
